import Skeleton from "@material-ui/lab/Skeleton";
import {
  LoaderPage,
  LoaderBox,
  LoaderSpinner,
  LoaderTitle,
  LoaderPercent,
  LoaderTrack,
  LoaderFill,
  LoaderHint,
  LoaderStats,
  LoaderStatRow,
  tableLoaderStyles,
} from "./loaderStyled";
import classnames from "classnames";

const defaultHintForMessage = (message, percent) => {
  const msg = String(message || "");
  if (/ai suggestion|finding ai/i.test(msg)) {
    return "Please wait — looking up cross-reference parts.";
  }
  if (/digikey|enrich|saving selections|fetching digikey/i.test(msg)) {
    return "Please wait — DigiKey enrichment can take a minute or two.";
  }
  if (percent > 0) {
    return "Please wait — do not close this window.";
  }
  return "";
};

/**
 * Full-screen interactive progress loader (spinner + message + % + bar).
 * Optional enrichmentStats: { total, succeeded, failed, in_progress, message }
 */
export const OverlayLoader = (props) => {
  const stats = props.enrichmentStats || null;
  const hasStats =
    stats &&
    (Number(stats.total) > 0 ||
      Number(stats.succeeded) > 0 ||
      Number(stats.failed) > 0 ||
      Number(stats.in_progress) > 0);

  const statsPercent =
    hasStats && Number(stats.total) > 0
      ? Math.round(
          ((Number(stats.succeeded) + Number(stats.failed)) /
            Number(stats.total)) *
            100,
        )
      : 0;

  const percent = Math.max(
    0,
    Math.min(
      100,
      hasStats && statsPercent > 0
        ? statsPercent
        : Number(props.scrappingPercent) || 0,
    ),
  );
  const message =
    (hasStats && stats.message) ||
    props.message ||
    "Processing data. Please wait.";
  const hint =
    props.hint !== undefined
      ? props.hint
      : defaultHintForMessage(message, percent);
  const hasPercent = percent > 0;
  const fillWidth = hasPercent ? Math.max(percent, 5) : 40;

  return (
    <LoaderPage className={classnames({ show: props.show })}>
      <LoaderBox>
        <LoaderSpinner aria-hidden="true" />
        <LoaderTitle>{message}</LoaderTitle>
        {hasPercent ? <LoaderPercent>{Math.round(percent)}%</LoaderPercent> : null}
        <LoaderTrack>
          <LoaderFill
            $indeterminate={!hasPercent}
            style={hasPercent ? { width: `${fillWidth}%` } : undefined}
          />
        </LoaderTrack>
        {hasStats ? (
          <LoaderStats>
            <LoaderStatRow>
              <span>Succeeded</span>
              <strong>
                {Number(stats.succeeded) || 0}
                {Number(stats.total) > 0 ? ` / ${Number(stats.total)}` : ""}
              </strong>
            </LoaderStatRow>
            <LoaderStatRow>
              <span>Failed</span>
              <strong>{Number(stats.failed) || 0}</strong>
            </LoaderStatRow>
            <LoaderStatRow>
              <span>In progress</span>
              <strong>{Number(stats.in_progress) || 0}</strong>
            </LoaderStatRow>
          </LoaderStats>
        ) : null}
        {hint ? <LoaderHint>{hint}</LoaderHint> : null}
      </LoaderBox>
    </LoaderPage>
  );
};

export const TableLoader = () => {
  const classes = tableLoaderStyles();
  return (
    <div className={classes.tableLoader}>
      <div className={classes.row}>
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
      </div>
      <div className={classes.row}>
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
      </div>
      <div className={classes.row}>
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
      </div>
      <div className={classes.row}>
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
        <Skeleton variant="rect" className={classes.cell} />
      </div>
    </div>
  );
};
